import { render, staticRenderFns } from "./dialog-set-days.vue?vue&type=template&id=0015872b&scoped=true"
import script from "./dialog-set-days.vue?vue&type=script&lang=js"
export * from "./dialog-set-days.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015872b",
  null
  
)

export default component.exports